import { AppDispatch } from 'src/app/rootStore';
import { toWords } from 'number-to-words';
import {
  DEEPGRAM_TTS_URL,
  RIME_TTS_URL,
  SPROUTS_AGENT_BASE_URL,
} from 'src/constants/httpEndPoints';
import { chatToolName, simpleChatToolName } from 'src/store/sprouts-agent/constants';
import {
  addNewMessage,
  appendExtraMessageDetailsToChat,
  appendMessage,
  appendSummarizationToChat,
  removeLastMessage,
  setChatStreaming,
  setCheckpoint,
  setFetchState,
  setIsAgentSpeaking,
  setMessageGenerating,
  setWelcomeVoice,
} from 'src/store/sprouts-agent/sprouts-agent.slice';
import { getCookie } from 'src/utils/cookies';

let abortControllerText = new AbortController();
let metadata = 'super';
let playbookInputFound = false;
let checkPoint = '';
function processSSEEvent(lines: any) {
  let eventType = 'message';
  const dataLines = [];
  for (const line of lines) {
    if (line.startsWith('event:')) {
      eventType = line.slice(6).trim();
    } else if (line.startsWith('data:')) {
      dataLines.push(line.slice(5).trim());
    }
  }
  const fullData = dataLines.join('\n');
  if (eventType === 'messages/metadata') {
    try {
      const mt = JSON.parse(fullData);
      if (mt) {
        Object.keys(mt).map((item) => {
          metadata = mt[item]?.metadata?.langgraph_node || 'super';
        });
      }
    } catch (e) {
      metadata = 'super';
    }
  }
  if (eventType === 'values') {
    try {
      const mt = JSON.parse(fullData);
      if (mt) {
        const key = Object.keys(mt)[0];
        if (key && mt[key]?.[0]?.id) {
          playbookInputFound = true;
          checkPoint = mt[key]?.[0]?.id;
        }
      }
    } catch (e) {
      //
    }
  }
  return {
    event: eventType,
    data: fullData,
  };
}
export const fetchStreamData = async (
  audioMode: boolean,
  dispatch: AppDispatch,
  emailId: string,
  customerId: string,
  threadId: string,
  audioRef: any,
  handleTimeUpdateRef: any,
  abortControllerRef: any,
  checkpoint_id?: string,
  message?: string,
  client_secret?: string,
  isCheckpointAvailable?: boolean,
) => {
  abortControllerText = new AbortController();
  const { signal } = abortControllerText;
  let summarizedText = '';
  try {
    if (signal.aborted) return;
    dispatch(
      addNewMessage({
        content: '',
        role: 'bot',
        contentType: 'simple-text',
      }),
    );
    dispatch(setMessageGenerating(true));
    dispatch(setChatStreaming(true));
    const response = await fetch(`${SPROUTS_AGENT_BASE_URL}/${threadId}/runs/stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        email: emailId,
        unique_id: customerId,
      },
      body: JSON.stringify({
        ...(!isCheckpointAvailable && {
          input: {
            messages: [
              {
                content: message,
                type: 'human',
              },
            ],
          },
        }),
        config: {
          configurable: {
            thread_ts: '1f02c843-4c10-6c56-8002-d089b98dc770',
            thread_id: threadId,
            email: emailId,
            unique_id: customerId,
            client_secret: getCookie('user'),
          },
        },
        metadata: { from_studio: true, LANGGRAPH_API_URL: 'http://127.0.0.1:2024' },
        stream_mode: ['debug', 'messages'],
        stream_subgraphs: true,
        assistant_id: process.env.SPROUTS_AGENT_ASSISTANT_ID,
        interrupt_before: [],
        interrupt_after: [],
        multitask_strategy: 'rollback',
        // checkpoint_id: checkpoint_id || '',
        checkpoint_during: true,
        ...(isCheckpointAvailable && {
          command: {
            resume: message,
          }
        })
      }),
      signal,
    });
    if (signal.aborted) return;
    if (!response.body) {
      throw new Error('ReadableStream not supported.');
    }
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let textBuffer = '';
    let eventBuffer = [];
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      const rawChunk = decoder.decode(value, { stream: true });
      textBuffer += rawChunk.replace(/\r\n/g, '\n');
      const lines = textBuffer.split('\n');
      if (textBuffer[textBuffer.length - 1] !== '\n') {
        textBuffer = lines.pop() || '';
      } else {
        textBuffer = '';
      }
      for (const line of lines) {
        if (line === '') {
          const res = processSSEEvent(eventBuffer);
          if (res.event === 'messages/partial') {
            try {
              const apM = JSON.parse(res.data);
              if (
                metadata === 'small_talk' ||
                metadata === 'exit' ||
                metadata === 'exit_supervisor'
              ) {
                dispatch(appendMessage({ message: apM[0]?.content, chatKey: 'sdi_agent' }));
                dispatch(appendSummarizationToChat(apM[0]?.content));
                summarizedText = apM[0]?.content;
              } else if (metadata === 'agent') {
                if (apM[0]?.content.includes('download_csv_link:')) {
                  dispatch(
                    appendMessage({
                      message: apM[0]?.content.split('download_csv_link:')[1] || '',
                      chatKey: 'download_csv_tool',
                    }),
                  );
                  dispatch(appendSummarizationToChat('Click the button to download the CSV.'));
                  summarizedText = 'Click the button to download the CSV.';
                } else {
                  dispatch(appendMessage({ message: apM[0]?.content, chatKey: 'sdi_agent' }));
                  dispatch(appendSummarizationToChat(apM[0]?.content));
                  summarizedText = apM[0]?.content;
                }
              } else if (metadata === 'tts_agent_sdi') {
                dispatch(appendSummarizationToChat(apM[0]?.content));
                summarizedText = apM[0]?.content;
              }
            } catch (e) {
              //
            }
          }
          eventBuffer = [];
        } else {
          eventBuffer.push(line);
        }
      }
    }
    dispatch(setCheckpoint(checkPoint));
    dispatch(setFetchState(playbookInputFound));
    dispatch(setChatStreaming(false));
    if (audioMode && !signal.aborted) {
      fetchAudioRime(summarizedText, dispatch, audioRef, handleTimeUpdateRef, abortControllerRef);
    }
  } catch (error: any) {
    if (error.name === 'AbortError') {
      console.log('Fetch aborted.');
    } else {
      if (audioMode && !signal.aborted) {
        fetchAudioRime(
          'Something went wrong. Please try again',
          dispatch,
          audioRef,
          handleTimeUpdateRef,
          abortControllerRef,
        );
      }
    }
    dispatch(
      appendMessage({
        message: 'Something went wrong. Please reach out to the admin.',
        chatKey: 'sdi_agent',
      }),
    );
    dispatch(setChatStreaming(false));
  }
};

export const stopStream = (dispatch: AppDispatch) => {
  abortControllerText.abort();
  dispatch(removeLastMessage());
  dispatch(setChatStreaming(false));
};

export const fetchNextStepData = async (
  audioMode: boolean,
  dispatch: AppDispatch,
  emailId: string,
  customerId: string,
  threadId: string,
  message: string,
  checkPoint: string,
  audioRef: any,
  handleTimeUpdateRef: any,
  abortControllerRef: any,
) => {
  try {
    abortControllerText = new AbortController();
    const { signal } = abortControllerText;
    if (signal.aborted) return;
    dispatch(setChatStreaming(true));
    const response2 = await fetch(`${SPROUTS_AGENT_BASE_URL}/${threadId}/state`, {
      method: 'POST',
      headers: {
        'Content-Type': 'text/plain',
      },
      body: JSON.stringify({
        values: {
          messages: [
            {
              content: message,
              type: 'human',
            },
          ],
        },
        checkpoint_ns: checkPoint.split(':')[1],
        as_node: checkPoint.split(':')[0].slice(0, checkPoint.split(':')[0].length),
      }),
      signal,
    });
    if (signal.aborted) return;

    const data1 = await response2.json();
    if (signal.aborted) return;
    await fetchStreamData(
      audioMode,
      dispatch,
      emailId,
      customerId,
      threadId,
      audioRef,
      handleTimeUpdateRef,
      abortControllerRef,
      data1.checkpoint_id,
      message,
    );
  } catch (error: any) {
    if (error.name === 'AbortError') {
      console.log('Fetch aborted.');
    } else {
      console.error('Error:', error);
    }
    dispatch(
      appendMessage({
        message: 'Something went wrong. Please reach out to the admin.',
        chatKey: 'sdi_agent',
      }),
    );
    dispatch(setChatStreaming(false));
  }
};

export const fetchAudio = async (
  value: string,
  dispatch: AppDispatch,
  audioRef: any,
  handleTimeUpdateRef: any,
  abortControllerRef: any,
) => {
  const text = value
    .replaceAll('e.g', 'as a example')
    .replaceAll('*', '')
    .replaceAll('#', '')
    .replaceAll('json', '')
    .replaceAll(`"`, '')
    .replaceAll('event:', '')
    .replaceAll('filter:', '')
    .replaceAll('sequence:', '')
    .replaceAll('{', '')
    .replaceAll('}', '')
    .replaceAll('[', '')
    .replaceAll(']', '')
    .replaceAll('ICP', 'I C P')
    .replaceAll('QA', 'Q A')
    .replaceAll('CRM', 'C R M')
    .replaceAll('GTM', 'G T M')
    .replaceAll('ABM', 'A B M')
    .replaceAll('.', '..')
    .replace(/([a-zA-Z]+),\s*([a-zA-Z]+)/g, '$1...$2')
    .replace(/\n/g, ',  ');
  try {
    dispatch(setWelcomeVoice());
    dispatch(setChatStreaming(true));
    const abortController = new AbortController();
    abortControllerRef.current = abortController;
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'text/plain',
        Authorization: `Token ${process.env.DEEPGRAM_API_KEY}`,
      },
      body: text,
      signal: abortController.signal,
    };

    try {
      const response = await fetch(DEEPGRAM_TTS_URL, options);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const audioBlob = await response.blob();
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      audioRef.current = audio;

      detectSilenceInRealTime(audioBlob, audio, dispatch, handleTimeUpdateRef);
      audio.addEventListener('ended', () => {
        dispatch(setIsAgentSpeaking(false));
        dispatch(setChatStreaming(false));
      });

      audio.play();
    } catch (error: any) {
      if (error.name === 'AbortError') {
        console.log('Fetch aborted successfully');
      } else {
        console.error('Error fetching or playing audio:', error);
      }
      dispatch(setIsAgentSpeaking(false));
      setChatStreaming(false);
    }
  } catch (error) {
    console.error('Error fetching or playing audio:', error);
    dispatch(setIsAgentSpeaking(false));
    setChatStreaming(false);
  }
};
export const fetchAudioRime = async (
  value: string,
  dispatch: AppDispatch,
  audioRef: any,
  handleTimeUpdateRef: any,
  abortControllerRef: any,
) => {
  let text = value
    .replaceAll('CSV', 'C S V')
    .replaceAll('csv', 'C S V')
    .replaceAll('Csv', 'C S V')
    .replace(/(?<=\d),(?=\d)/g, '')
    .replace(/\n/g, '.');
  text = text.replace(/\b\d+\b/g, (match) => {
    const num = parseInt(match, 10);
    return num <= Number.MAX_SAFE_INTEGER ? toWords(num) : match;
  });
  text = splitAllCapsWords(text);
  text = text.length > 500 ? text.substring(0, 500) : text;
  try {
    dispatch(setWelcomeVoice());
    dispatch(setChatStreaming(true));

    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    const response = await fetch(RIME_TTS_URL, {
      method: 'POST',
      headers: {
        Accept: 'audio/mp3',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.RIME_API_KEY}`,
      },
      body: JSON.stringify({
        speaker: 'Stream',
        text,
        modelId: 'mistV2',
        lang: 'eng',
        samplingRate: 22050,
        speedAlpha: 0.9,
        reduceLatency: false,
        pauseBetweenBrackets: true,
        phonemizeBetweenBrackets: true,
        inlineSpeedAlpha: '0.5, 3',
      }),
      signal: abortController.signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const audioBlob = await response.blob();
    const audioUrl = URL.createObjectURL(audioBlob);
    const audio = new Audio(audioUrl);
    audioRef.current = audio;

    detectSilenceInRealTime(audioBlob, audio, dispatch, handleTimeUpdateRef);

    audio.addEventListener('ended', () => {
      dispatch(setIsAgentSpeaking(false));
      dispatch(setChatStreaming(false));
    });

    await audio.play();
  } catch (error: any) {
    if (error.name === 'AbortError') {
      console.log('Fetch aborted successfully');
    } else {
      console.error('Error fetching or playing audio:', error);
    }
    dispatch(setIsAgentSpeaking(false));
    dispatch(setChatStreaming(false));
  }
};

const detectSilenceInRealTime = async (
  audioBlob: Blob,
  audio: HTMLAudioElement,
  dispatch: AppDispatch,
  handleTimeUpdateRef: any,
) => {
  const audioContext = new AudioContext();
  const arrayBuffer = await audioBlob.arrayBuffer();
  const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
  const channelData = audioBuffer.getChannelData(0);
  const SILENCE_THRESHOLD = 0.01;
  const SILENCE_DURATION = 0.45;
  const sampleRate = audioBuffer.sampleRate;
  const silenceSamples = SILENCE_DURATION * sampleRate;
  let silentStart = -1;
  const silences = [];
  for (let i = 0; i < channelData.length; i++) {
    if (Math.abs(channelData[i]) < SILENCE_THRESHOLD) {
      if (silentStart === -1) {
        silentStart = i;
      }
    } else {
      if (silentStart !== -1 && i - silentStart > silenceSamples) {
        silences.push({
          start: silentStart / sampleRate,
          end: i / sampleRate,
        });
      }
      silentStart = -1;
    }
  }

  const handleTimeUpdate = () => {
    const currentTime = audio.currentTime;
    const isSilent = silences.some((s) => currentTime >= s.start && currentTime <= s.end);
    dispatch(setIsAgentSpeaking(!isSilent));
  };
  handleTimeUpdateRef.current = handleTimeUpdate;
  audio.addEventListener('timeupdate', handleTimeUpdate);
  const cleanup = () => {
    audio.removeEventListener('timeupdate', handleTimeUpdate);
  };
  audio.addEventListener('ended', cleanup);
  audio.addEventListener('pause', cleanup);
};

export const stopAudioPlayback = (
  handleTimeUpdateRef: any,
  audioRef: any,
  dispatch: AppDispatch,
  abortControllerRef: any,
) => {
  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    if (handleTimeUpdateRef.current) {
      audioRef.current.removeEventListener('timeupdate', handleTimeUpdateRef.current);
    }
  }
  if (abortControllerRef.current) {
    abortControllerRef.current.abort();
  }
  dispatch(setChatStreaming(false));
  dispatch(setIsAgentSpeaking(false));
};
export const getCleanMarkdownString = (markdown: string | undefined | null): string => {
  if (!markdown) return '';

  // Step 1: Replace common escaped characters
  let cleaned = markdown.replace(/\\[ntrfbv'"\\0]/g, (match) => {
    switch (match) {
      case '\\n':
        return '\n'; // New line
      case '\\t':
        return '\t'; // Tab
      case '\\r':
        return '\r'; // Carriage return
      case '\\f':
        return '\f'; // Form feed
      case '\\b':
        return '\b'; // Backspace
      case '\\v':
        return '\v'; // Vertical tab
      case "\\'":
        return "'"; // Single quote
      case '\\"':
        return '"'; // Double quote
      case '\\\\':
        return '\\'; // Backslash
      case '\\0':
        return '\0'; // Null character
      default:
        return match;
    }
  });

  // Step 2: Fix broken numbered lists (e.g., "1.\nSome text" → "1. Some text")
  cleaned = cleaned.replace(/^(\d+)\.\s*\n\s*(?=\S)/gm, '$1. ');

  return cleaned;
};

const EXCEPTIONS = ['TAL'];
const exceptionPattern = EXCEPTIONS.join('|');
const splitAllCapsWords = (text: string) => {
  return text.replace(new RegExp(`\\b(?!${exceptionPattern}\\b)[A-Z]{2,}\\b`, 'g'), (match) =>
    match.split('').join(' '),
  );
};
